import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ExpenseReportLine } from 'app/core/model/expense-report-line';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService } from 'app/core/auth.service';
import { ExpenseReport } from 'app/core/model/expense-report';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { confirm } from 'devextreme/ui/dialog';
import { ExpenseReportLineDialogComponent } from '../expense-report-line-dialog/expense-report-dialog.component';

@Component({
    selector: 'app-expense-report-detail',
    templateUrl: './expense-report-detail.component.html',
    styleUrls: ['./expense-report-detail.component.scss'],
    standalone: false,
})
export class ExpenseReportDetailComponent implements OnInit {
    key: any;
    expenseReport: ExpenseReport;
    lines: any[];

    constructor(
        public uow: GenesisUnitOfWork,
        public route: ActivatedRoute,
        public location: Location,
        public router: Router,
        public modalService: BsModalService,
        public appInfo: AppInformationService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        this.key = this.route.snapshot.params['id'];
        if (this.key === 'new') {
            this.expenseReport = this.uow.expenseReports.createEntity() as ExpenseReport;
            this.expenseReport.expenseDate = new Date();
            this.expenseReport.created = new Date();
            this.expenseReport.createdBy = this.auth.currentUser.userName;
        } else {
            this.expenseReport = (await this.uow.expenseReports.byId(this.key, 'lines, lines.attachments, lines.expenseType')) as ExpenseReport;
            this.lines = this.expenseReport.lines.filter((x) => !x.deleted);
            this.lines.forEach((x) => (x.photos = x.attachments.filter((x) => !x.deleted)));
            this.expenseReport._totalAmount = this.expenseReport.calcTotalAmount();
        }
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }

    async save() {
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        if (this.key === 'new') {
            this.router.navigate(['../' + this.expenseReport.id], { relativeTo: this.route, replaceUrl: true, state: { navigateOnSaveNew: true } });
        }
        this.key = this.expenseReport.id;
        this.appInfo.pleaseWaitHide();
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    onRowDoubleClick(e) {
        this.openLine(e.data);
    }

    async openLine(line?: ExpenseReportLine) {
        const modalRef = this.modalService.show(ExpenseReportLineDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                expenseLine: line,
                expenseReport: this.expenseReport,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
            if (result.success) {
                await this.save();
            }
            this.lines = this.expenseReport.lines.filter((x) => !x.deleted);
            this.lines.forEach((x) => (x.photos = x.attachments.filter((x) => !x.deleted)));
            this.expenseReport._totalAmount = this.expenseReport.calcTotalAmount();
        });
    }

    async deleteLine(line) {
        const result = await confirm(`Are you sure you want to DELETE this entry?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        line.deleted = new Date();
        line.deletedBy = this.auth.currentUser.userName;
        await this.save();

        this.lines = this.expenseReport.lines.filter((x) => !x.deleted);
        this.expenseReport._totalAmount = this.expenseReport.calcTotalAmount();
    }
}
